import { Modules, Norms } from 'sigma-mappings';
import chromatographyFieldsData from './diagnostic-history-chromatography-fields.json';
import physicalChemicalFieldsData from './diagnostic-history-physical-chemical-fields.json';

const getFields = (vm, data) => {
  if (!vm) return [];
  const fieldsList = [];
  data.forEach(item => fieldsList.push({
    key: item.key,
    label: vm.$t(item.label, item.tParams || undefined),
    enumLabelPrefix: item.enumLabelPrefix,
    isMethod: item.isMethod,
    isTest: item.isTest,
    normFilterKey: Norms[item.normFilterKey] || undefined,
  }));
  return fieldsList;
};

export default vm => ({
  [Modules.CHROMATOGRAPHY]: getFields(vm, chromatographyFieldsData),
  [Modules.PHYSICAL_CHEMICAL]: getFields(vm, physicalChemicalFieldsData),
});
